<template>
  <v-dialog v-model="loading" persistent width="300">
    <v-card class="bg-primary" dark>
      <v-card-text class="text-center">
        لطفا کمی صبر کنید...
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      loading: true
    };
  }
};
</script>
